import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AuthService } from '../../core';

@Component({
  selector: 'change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  form: FormGroup;
  loading: boolean = false;

  constructor(
    private titleService: Title,
    private fb: FormBuilder,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.titleService.setTitle('Cambiar Contraseña - Drift');

    this.form = this.fb.group({
      password: ['', Validators.required],
      confirm: ['', Validators.required]
    }, { validator: this.passwordMatcher });
  }

  isValid(field: string, error: string = '') {   
    let formField: AbstractControl = (field == 'form') ? 
      this.form :
      this.form.get(field)
    ;

    if ((formField.touched === false) && (formField.pristine === true)) {
      return true;
    }

    return (error == '') ? formField.valid : !formField.hasError(error);
  }

  save() {
    if (this.form.valid === false) {
      this.showErrors();
    } else {
      this.loading = true;

      this.authService
        .changePassword(this.form.get('password').value)
        .subscribe(() => {
          this.loading = false;
          this.form.reset();
        })
      ;
    }
  }

  private showErrors() {
    for (var i in this.form.controls) {
      this.form.controls[i].markAsTouched();
    }
  }

  private passwordMatcher(c: AbstractControl) {
    if (c.get('password').value == '' || c.get('confirm').value == '') {
      return null;
    }
    
    return c.get('password').value === c.get('confirm').value ? null : { nomatch: true };
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/login/change-password/change-password.component.ts